import LiveDrawSetupDialog from "./liveDrawSetupDialog.container";

export default LiveDrawSetupDialog;